function SingleStore({ store }) {
    return (
        <div className="store-card w-100 mx-auto overflow-hidden p-3 d-flex">
            <div style={{ width: "50%", display: 'flex', alignItems: "start", flexDirection: "column", justifyContent: "center" }}>
                {/* Store Name */}
                <p className="fw-bold mb-1 text-blue-white fs-5">{store?.loc_name}</p>

                {/* Address */}
                <p className="text-muted font-size-13 text-wafaa-black-1">
                    <span className="fa-solid fa-location-dot text-primary me-2"></span>
                    {store?.address || "No address available"}
                </p>

                {/* Contact Details */}
                <p className="text-muted font-size-13 text-wafaa-black-1">
                    <span className="fa-solid fa-phone text-success me-2"></span>
                    {store?.phone}
                </p>
            </div>


                {/* Call & Directions Buttons */}
                <div style={{width: "50%"}} className="d-flex flex-column justify-content-around align-items-end" >
                    <a href={`tel:${store?.phone}`} className="store-btn call-btn" style={{width: 'fit-content'}}>
                        <span className="fa-solid fa-phone"></span>
                        <span className="ms-2">Call</span>
                    </a>

                    <a href={store?.address_map} target="_blank" rel="noopener noreferrer" className="store-btn directions-btn" style={{width: 'fit-content'}}>
                        <span className="fa-solid fa-location-arrow"></span>
                        <span className="ms-2">Directions</span>
                    </a>
                </div>
        </div>
    );
}

export default SingleStore;
